import BasePaywall from './BasePaywall';
import BasePaywallContainer from './BasePaywall.container';

export default BasePaywallContainer(BasePaywall);
